import _import from './_import';
// 我的
export default [
  {
    path: '/',
    component: _import ('layout/index'),
    children: [
      {
        path: '/mine',
        name: 'Mine',
        component: _import ('mine'),
        meta: {
          title: '我的',
        },
        children: [
          {
            path: 'entry',
            name: 'mineEntry',
            component: _import ('mine/entry'),
            meta: {title: '我的',},
          },
          {
            path: 'login',
            name: 'mineLogin',
            component: _import ('mine/login'),
            meta: {title: '登陆'},
          },
          {
            path: 'mineapdetail',
            name: 'MineAPDetail',
            component: _import ('mine/apdetail'),
            meta: {title: '工序报工'},
          },
          {
            path: 'minepartidinfo',
            name: 'MinePartidInfo',
            component: _import ('mine/partidinfo'),
            meta: {title: '报工存货编码开窗'},
          },
          {
            path: 'minebguser',
            name: 'MinebgUser',
            component: _import ('mine/bguser'),
            meta: {title: '报工人员'},
          },
          {
            path: 'settingtax',
            name: 'mineSettingtax',
            component: _import ('mine/settingtax'),
            meta: {title: '开票设置'},
          },
          
          {
            path: 'mineamtoutvouch',
            name: 'MineAmtOutVouch',
            component: _import ('mine/amtoutvouch'),
            meta: {title: '工序报废'},
          },
          {
            path: 'minescrapinfo',
            name: 'MineScrapInfo',
            component: _import ('mine/scrapinfo'),
            meta: {title: '报废审批'},
          },
          {
            path: 'minescrapreissue',
            name: 'MineScrapReissue',
            component: _import ('mine/scrapreissue'),
            meta: {title: '报废补料'},
          },
          
          {
            path: 'minebfpartstdinfo',
            name: 'MinebfPartstdInfo',
            component: _import ('mine/bfpartstdinfo'),
            meta: {title: '报废存货规格开窗'},
          },
          {
            path: 'minebginfo',
            name: 'MineBgInfo',
            component: _import ('mine/bginfo'),
            meta: {title: '报工明细'},
          },
          {
            path: 'mineplbginfo',
            name: 'MinePlBgInfo',
            component: _import ('mine/plbginfo'),
            meta: {title: '批量报工'},
          },
          {
            path: 'minebfinfo',
            name: 'MineBfInfo',
            component: _import ('mine/bfinfo'),
            meta: {title: '报废列表'},
          },
          {
            path: 'setting',
            name: 'mineSetting',
            component: _import ('mine/setting'),
            meta: {title: '个人信息'},
          },
          {
            path: 'bill',
            name: 'mineBill',
            component: _import ('mine/bill'),
            meta: {title: '进出明细'},
          },
          {
            path: 'minebgcheck',
            name: 'MineBgCheck',
            component: _import ('mine/bgcheck'),
            meta: {title: '报工审批'},
          },
          {
            path: 'mineabnormal',
            name: 'MineAbnormal',
            component: _import ('mine/abnormal'),
            meta: {title: '异常报工'},
          },
          {
            path: 'minepartidinfo2',
            name: 'MinePartidInfo2',
            component: _import ('mine/partidinfo2'),
            meta: {title: '异常报工存货编码开窗'},
          },
          {
            path: 'minecheckuserinfo',
            name: 'MineCheckuserInfo',
            component: _import ('mine/checkuserinfo'),
            meta: {title: '员工编码开窗'},
          },
          {
            path: 'minescgodown',
            name: 'MineSCGodown',
            component: _import ('mine/scgodown'),
            meta: {title: '生产入库'},
          },
          
          
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/mine.js